import { FormControlLabel, Switch, Typography } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { PagamentoResponse, PagamentoStatus } from 'common/genericTypes';
import { GenericDrawer } from 'components/genericDrawer';
import { NumberField, SmSpace, TextField } from 'm2m.components';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { formatDate } from 'utils/date';

interface SolicitarLiquidacaoBrutaEmissorDrawerProps {
  pagamento?: PagamentoResponse;
  opened: boolean;
  onClose(): void;
  onSubmitSuccess?(): void;
}

export const SolicitarLiquidacaoBrutaEmissorDrawer: React.FC<SolicitarLiquidacaoBrutaEmissorDrawerProps> = ({
  pagamento,
  opened,
  onClose,
  onSubmitSuccess,
}) => {
  const [rejeitarPu, setRejeitarPu] = useState(false);
  const [puEmissor, setPuEmissor] = useState<number>(0);

  const dispatch = useDispatch();
  const { postSolicitarAprovacaoAF } = useSelector((state: RootState) => state.instrumentoApi);

  const isReprovadoAF = pagamento?.status === PagamentoStatus.ReprovadoAgenteFiduciario;

  useEffect(() => {
    if (!opened) {
      setRejeitarPu(false);
      setPuEmissor(0);
    }
  }, [opened]);

  const handleSubmit = async () => {
    if (!pagamento) return;

    try {
      await postSolicitarAprovacaoAF(dispatch, pagamento.id, {
        puEmissor: rejeitarPu ? puEmissor : undefined,
        aceitouPUProjetado: !rejeitarPu,
      });
      onSubmitSuccess?.();
    } catch {}
  };

  const drawerTitle = isReprovadoAF
    ? 'Solicitar Liquidação - Reprovado A.F.'
    : 'Solicitar Liquidação';

  const puLabel = isReprovadoAF ? 'PU Agente Fiduciário' : 'PU Projetado';
  const puValue = pagamento?.puProjetado ?? 0;

  return (
    <GenericDrawer
      opened={opened}
      onClose={onClose}
      title={drawerTitle}
      buttons={[
        {
          buttonText: 'Solicitar Liquidação',
          buttonAction: handleSubmit,
          buttonColor: 'primary',
        },
        {
          buttonText: 'Cancelar',
          buttonAction: onClose,
        },
      ]}
    >
      <TextField
        label="Data do Vencimento"
        value={pagamento?.dataVencimento ? formatDate(pagamento.dataVencimento) : ''}
        disabled
      />
      <SmSpace />

      <NumberField
        label={puLabel}
        value={puValue}
        onChange={() => {}}
        numberType="eightDecimals"
        disabled
      />
      <SmSpace />

      <FormControlLabel
        control={
          <Switch
            color="primary"
            checked={rejeitarPu}
            onChange={() => setRejeitarPu(!rejeitarPu)}
          />
        }
        label={
          <Typography variant="body2">
            {isReprovadoAF
              ? 'Reprovar valor do PU do Agente Fiduciário'
              : 'Reprovar valor do PU Projetado'}
          </Typography>
        }
      />
      <SmSpace />

      {rejeitarPu && (
        <>
          <NumberField
            label="PU Emissor"
            value={puEmissor}
            onChange={(value) => setPuEmissor(value ?? 0)}
            numberType="eightDecimals"
            required
          />
          <SmSpace />
        </>
      )}

      {!rejeitarPu && (
        <div
          style={{
            padding: '20px',
            border: '2px solid #FFCF40',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <ErrorIcon style={{ marginRight: 10 }} fontSize="small" />
          <Typography variant="body1">
            Ao clicar em "Solicitar liquidação" você concorda com o valor de PU projetado indicado pela Laqus
          </Typography>
        </div>
      )}

      <div style={{ marginTop: 64 }} />
    </GenericDrawer>
  );
};
